import type { Project } from "@tasduvar/engine";

/** FNV-1a 32 bit; senkron, bağımlılıksız. Raporda "dosya özeti" olarak basılır. */
export function fnv1a(text: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) { h ^= text.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
  return h.toString(16).padStart(8, "0");
}

/** updatedAt/createdAt hariç proje içeriğinin özeti: aynı girdiler → aynı özet. */
export function fileDigest(project: Project): string {
  const { updatedAt: _u, createdAt: _c, ...rest } = project;
  return fnv1a(JSON.stringify(rest));
}
